import _ from "lodash";
import client from "lib/apolloClient/client";
import {
  getStaffCurriculumProgramsQuery,
  getStaffCoursesQuery,
  getStaffLearningCoursesQuery,
} from "./Queries";

export const getStaffCurriculumProgramsQueryFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getStaffCurriculumProgramsQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getStaffCoursesQueryFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getStaffCoursesQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getStaffLearningCoursesQueryFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getStaffLearningCoursesQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};
